import { Col, Container, Row } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css/pagination';
import user1 from "../../assets/user_images/user4.jpg";
import user2 from "../../assets/user_images/user5.jpg";
import user3 from "../../assets/user_images/user6.jpg";

const testimonialsData = [
    {
        id: 1,
        name: 'Sarah Johnson',
        position: 'CEO, TechStart Inc.',
        image: user1,
        feedback: "Their SEO strategies transformed our online presence. We've seen a 200% increase in organic traffic and a boost in qualified leads. The team is responsive, knowledgeable, and genuinely invested in our success.",
        rating: 5
    },
    {
        id: 2,
        name: 'Michael Chen',
        position: 'Marketing Director, Global Retail',
        image: user2,
        feedback: "The PPC campaigns exceeded our expectations. We saw a 150% increase in conversions while cutting costs by 30%. Their data-driven approach and transparency are unmatched.",
        rating: 5
    },
    {
        id: 3,
        name: 'Emily Rodriguez',
        position: 'Founder, Wellness Collective',
        image: user3,
        feedback: "Their social media strategies helped us build a loyal community. Engagement is up 300%, and our brand presence has never been stronger.",
        rating: 4.5
    }
]

const Feedback = () => {
    const renderStars = (rating) => {
        const stars = []
        const fullStars = Math.floor(rating)
        const hasHalfStar = rating % 1 !== 0

        for (let i = 0; i < fullStars; i++) {
            stars.push(<i key={`full-${i}`} className="ri-star-fill"></i>)
        }
        if (hasHalfStar) {
            stars.push(<i key="half" className="ri-star-half-fill"></i>)
        }
        return stars
    }

    return (
        <section className='section-lg bg-light'>
            <Container>
                <Row>
                    <Col lg={8} className="mx-auto text-center">
                        <div className="service-heading mb-3">
                            <h6 className="underline-after position-relative z-0"><span className="position-relative z-1 bg-white text-primary px-3">Client Feedback</span></h6>
                            <h2 className="d-block text-gradiant text-center fw-semibold ">What Our Clients Say</h2>
                        </div>
                        <p className="lead text-secondary">Don't just take our word for it. Here's what our clients have to say about our digital marketing services.</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <Swiper className="testimonial-swiper"
                            modules={[Pagination, Autoplay]}
                            spaceBetween={24}
                            slidesPerView={2}
                            loop={true}
                            pagination={{ clickable: true }}
                            autoplay={{ delay: 5000, disableOnInteraction: false }}
                        >
                            {testimonialsData.map((testimonial) => (
                                <SwiperSlide key={testimonial.id}>
                                    <div className="card border-0 shadow-sm rounded-4">
                                        <div className="card-body p-4">
                                            <div className="d-flex align-items-center mb-4">
                                                <img src={testimonial.image} className="rounded-circle me-3 border border-2 border-success-subtle"  alt={testimonial.name}  width="60"  height="60"/>
                                                <div>
                                                    <h5 className="fw-semibold mb-1 text-dark">{testimonial.name}</h5>
                                                    <p className="text-secondary mb-0 small">{testimonial.position}</p>
                                                </div>
                                            </div>
                                            <p className="text-secondary mb-3 fst-italic">"{testimonial.feedback}"</p>
                                            <div className="text-warning">
                                                {renderStars(testimonial.rating)}
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Feedback;
